import { Colors } from 'utils';
import { makeStyles } from '@mui/styles';

export const staffModalsStyle = makeStyles(() => ({
    paycodeBox: {
        display: 'flex',
        // marginBottom: 16,
        alignItems: 'center',
    },
    paycodeBoxTitle: {
        color: Colors.TextPrimary,
        fontSize: 14,
        fontWeight: 'bold',
        marginRight: 8,
    },
    paycodeBoxText: {
        color: '#4B5C68B3',
        fontSize: 14,
    },
    activePaycode: {
        color: Colors.TextPrimary,
        fontSize: 16,
        marginLeft: 10,
    },
    codeAndTypeBoxStyle: {
        width: '100%',
        height: '112px',
        padding: '0 16px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: Colors.BackgroundWater,
        marginBottom: '24px',
    },
    paycodeModalStyle: {
        backgroundColor: Colors.BackgroundWhite,
        textAlign: 'left',
        '& p': { textAlign: 'left' },
        '& button': { backgroundColor: Colors.BackgroundWater },
        paddingBottom: '0',
    },
    credentialTypeBoxStyle: {
        width: '100%',
        padding: '24px 16px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: Colors.BackgroundWater,
        marginBottom: '16px',
        borderRadius: '4px',
    },

    typeBtn: {
        display: 'flex',
        width: '400px',
        padding: '12px 16px',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '48px',
        color: '#FFF',
        fontSize: '16px',
        fontWeight: '600',
        lineHeight: '22px',
        borderRadius: '4px',
        background: '#347AF0',
        marginBottom: '16px',
        border: 'none',
    },

    // Assign Zoom Modal

    zoomModalSubtitle: {
        fontSize: 14,
        color: Colors.TextMiddleGray,
        margin: '4px 0 0 0',
    },
    // zoomModalLoading: {
    //     color: Colors.TextPrimary,
    //     fontSize: 14,
    //     padding: '16px 0',
    // },
    zoomModalEmpty: {
        color: Colors.TextPrimary,
        fontSize: 14,
        padding: '16px 0',
    },
    zoomModalList: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },

    zoomModalItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '8px',
        borderRadius: 4,
        cursor: 'pointer',
        border: `1px solid '#E4E7EC'`,
        background: Colors.BackgroundWhite,
    },

    zoomModalItemSelected: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '8px',
        borderRadius: 4,
        cursor: 'pointer',
        border: '1px solid #B4D0F6',
        background: '#F5F9FE',
    },
    zoomModalRadio: {
        width: 18,
        height: 18,
        borderRadius: '50%',
        border: `2px solid ${Colors.TextCadetBlue}`,
        boxSizing: 'border-box',
        flexShrink: 0,
    },
    zoomModalRadioSelected: {
        width: 18,
        height: 18,
        borderRadius: '50%',
        border: `5px solid ${Colors.ThemeBlue}`,
        boxSizing: 'border-box',
        flexShrink: 0,
    },
    zoomModalUserName: {
        fontSize: 14,
        fontWeight: 400,
        color: '#172B4D',
        lineHeight: 'normal',
        margin: 0,
    },
    zoomModalUserEmail: {
        fontSize: 12,
        color: '#6B7280',
        lineHeight: 'normal',
        margin: 0,
    },
}));
